export default class AlUsersGridViewController {

    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;

        this.api = this.injector.get('$http');
        this.depositHelper = this.injector.get('Deposit');
        this.usersStore = this.injector.get('Users');

        this.hideHeader = false;
        this.onSwitchToListView = () => {
        };

        this.loading = true;
        this.localStorageKey = 'AlUsersGridViewFastPipeConfig';
        this.users = [];
        this.userStates = [
            {
                value: 'active',
                label: 'Active'
            },
            {
                value: 'pending',
                label: 'Pending'
            },
            {
                value: 'archived',
                label: 'Archived'
            },
            {
                value: 'inactive',
                label: 'Inactive'
            },
        ];

        this._initFastPipeConfiguration();

        this.sortDirections = [
            {
                key: 'asc',
                name: 'A-Z'
            },
            {
                key: 'desc',
                name: 'Z-A'
            }
        ];

        this.sortFields = [
            {
                field: 'master_user.full_name',
                name: 'sort by name'
            },
            {
                field: 'status',
                name: 'sort by status'
            }
        ];

        this._loadUsers();
    }

    $onInit() {
        this._initWatchers();
    }

    refreshUsers() {
        this.loading = true;
        localStorage.setItem(this.localStorageKey, JSON.stringify(this.fastPipeConfiguration));
        this._loadUsers();
    }

    updateFastPipeConfigurationField(fieldName, value) {
        _.set(this.fastPipeConfiguration, fieldName, value);
        this.refreshUsers();
    }

    switchToListView() {
        this.onSwitchToListView();
    }

    _loadUsers() {
        this.api
            .post(
                'fp/users',
                this._getBodyDataForUsersRequest()
            )
            .then(({data}) => {
                this.users = _.map(data.data, (user) => {
                    return this._transformInUser(user);
                });
                this.loading = false;
            })
    }

    _transformInUser(user) {
        return _.cloneDeep(user)
    }

    _getBodyDataForUsersRequest() {
        const filters = [];

        if (
            !this.usersStore.state.loggedin
            || !this.usersStore.state.loggedin.profile
            || !this.usersStore.state.loggedin.profile.sys_admin
        ) {
            filters.push({
                field: 'master_user.sys_admin',
                operator: '=',
                value: false
            })
        }

        if (
            this.fastPipeConfiguration.statusFilter
            && this.fastPipeConfiguration.statusFilter.length > 0
        ) {
            filters.push({
                operator: 'group',
                filters: _.filter(_.map(this.fastPipeConfiguration.statusFilter, (status) => {
                    switch (status) {
                        case 'active':
                            return {
                                boolean: 'or',
                                operator: 'group',
                                filters: [
                                    {
                                        field: 'deleted_at',
                                        operator: '=',
                                        value: null
                                    },
                                    {
                                        field: 'master_user.status',
                                        operator: '=',
                                        value: 'activated'
                                    }
                                ]
                            };

                        case 'pending':
                            return {
                                boolean: 'or',
                                operator: 'group',
                                filters: [
                                    {
                                        field: 'deleted_at',
                                        operator: '=',
                                        value: null
                                    },
                                    {
                                        field: 'master_user.status',
                                        operator: '=',
                                        value: 'needs_activation'
                                    }
                                ]
                            };

                        case 'inactive':
                            return {
                                boolean: 'or',
                                operator: 'group',
                                filters: [
                                    {
                                        field: 'deleted_at',
                                        operator: '=',
                                        value: null
                                    },
                                    {
                                        field: 'master_user.status',
                                        operator: '=',
                                        value: 'deactivated'
                                    }
                                ]
                            };


                        case 'archived':
                            return {
                                boolean: 'or',
                                field: 'deleted_at',
                                operator: '!=',
                                value: null
                            };

                    }
                }))
            })
        }

        const out = {
            fields: [
                'id',
                'master_user.profile_image',
                'master_user.email',
                'master_user.status',
                'role',
                'deleted_at',
                'master_user.full_name',
                'master_user.sys_admin'
            ],
            filters,
            includeArchived: true,
            keyword: this.fastPipeConfiguration.keyword,
            pagination: {
                perPage: -1
            },
            sort: {}
        };

        out.sort[this.fastPipeConfiguration.sortField] = this.fastPipeConfiguration.sortDirection;

        return out;
    }

    _initWatchers() {
        this.scope.$watch(
            () => this.fastPipeConfiguration.keyword,
            () => this.refreshUsers(),
            true
        );
    }

    _initFastPipeConfiguration() {
        let config = {
            statusFilter: [],
            keyword: '',
            sortField: 'settings_start_date',
            sortDirection: 'desc'
        };

        const localStorageContents = localStorage.getItem(this.localStorageKey);
        try {
            config = _.defaults(JSON.parse(localStorageContents), config);
        } catch (e) {
        }
        config.keyword = '';

        this.fastPipeConfiguration = config;
    }
}

AlUsersGridViewController.$inject = [
    '$scope',
    '$injector'
]



// WEBPACK FOOTER //
// ./src/app/modules/users/components/al-users-grid-view/controller.js